import { Link } from "react-router-dom";
import { FaInstagram, FaWhatsapp, FaEnvelope } from "react-icons/fa";
import "./header.css";

export default function Header() {
  return (
    <div className="header-container">
      {/* Barra superior de contacto */}
      <div className="topbar">
        <a href="https://instagram.com/cecy_vale84" target="_blank" rel="noopener noreferrer">
          <FaInstagram /> Ver Instagram
        </a>

        <a href="https://wa.me/5492616504890" target="_blank" rel="noopener noreferrer">
          <FaWhatsapp /> Enviar WhatsApp
        </a>

        <a href="mailto:cecyvale0207@gmail.com">
          <FaEnvelope /> Enviar Correo
        </a>
      </div>


      {/* Header principal */}
      <header className="header">
        <div className="logo">
          <img src="/images/logos/logo1.webp" alt="Logo" className="logo-img" />
        </div>

        <nav className="nav">
          <Link to="/">Home</Link>
          <Link to="/servicios">Servicios</Link>
          <Link to="/sobre-mi">Sobre Mi</Link>
          <Link to="/blog">Blog</Link>
          <Link to="/contacto">Contacto</Link>
        </nav>
      </header>
    </div>
  );
}
